import { useState } from "react";
import MainBanner from "../Banners/MainBanner";
import MobileMainBanner from "../Banners/MobileMainBanner";
import FooterComponent from "../Footer/FooterComponent";
import FeaturedGames from "../General/FeaturedGames";
import InnerBanner from "../General/InnerBanner";
import HeaderComponent from "../Header/HeaderComponent";
import LoginModalWrapper from "../Modal/loginModal/LoginModalWrapper";
import GamesWrapper from "../General/GameboardWrapper";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Promotions from "../../Components/Layouts/Promotions";
import { useAtom } from "jotai";
import PoyaBanneer from "../Poya/PoyaBanneer";
import CryptoBanner from "../Poya/CryptoBanner";


import { preLoader } from "../../DataStore/atom";
const FirstPage = ({
  openPopup,
  setOpenCashier,
  selectedGameAreaType,
  setSelectedGameType,
  modalStatus,
  modalType,
  openLoginPopup,
  closePopup,
  changeContent,
  generalModalStatus,
  generalModalType,
  openGeneralModal,
  gameWrapperArea,
  loading
}) => {
  const [preLoaderCoin, setPreLoader] = useAtom(preLoader);

  // const history = useHistory();
  // const checkLogin = () => {
  //   sessionStorage.getItem("login") && history.push("/lobby");
  // };
  const history = useHistory();
  const checkLogin = ()=>{
      // console.log(localStorage.getItem('login'))
      localStorage.getItem('login')&&history.push('/lobby')
  }
  useEffect(() => {
    setOpenCashier(false);
    checkLogin();
  }, []);

  useEffect(() => {
    let loc = window.location.href;
    // Prefer URL parsing (handles `/?tryget=signup#LK965` reliably)
    try {
      const url = new URL(loc);
      const tryget = (url.searchParams.get("tryget") || "").toLowerCase();
      const promoFromHash = (url.hash || "").replace(/^#/, "").trim();
      const isPromoSignupUrl = tryget === "signup" || tryget === "register";

      if (url.pathname.replace(/\/+$/, "").endsWith("login")) {
        openLoginPopup("login");
      }

      if (isPromoSignupUrl) {
        openLoginPopup("register");
      }

      // Keep promo code ONLY when the current URL is a promo-signup URL with a hash code.
      if (isPromoSignupUrl && promoFromHash) {
        openLoginPopup("register");
        localStorage.setItem("promoCode", promoFromHash);
        localStorage.setItem("promocode", promoFromHash);
      } else {
        localStorage.removeItem("promoCode");
        localStorage.removeItem("promocode");
      }
    } catch (e) {
      // Fallback for older environments
      var splitted = loc.split("/");
      let tst = splitted.slice(-1).pop();
      if (tst == "login") {
        openLoginPopup("login");
      }

      const queryPart = loc.split("?")[1] || "";
      const hashPart = (loc.split("#")[1] || "").trim();
      const isPromoSignupUrl = /(^|&)tryget=(signup|register)(&|$)/i.test(queryPart);

      if (isPromoSignupUrl) {
        openLoginPopup("register");
      }

      if (isPromoSignupUrl && hashPart) {
        openLoginPopup("register");
        localStorage.setItem("promoCode", hashPart);
        localStorage.setItem("promocode", hashPart);
      } else {
        localStorage.removeItem("promoCode");
        localStorage.removeItem("promocode");
      }
    }
  }, []);
  loading ? setPreLoader(true) : setPreLoader(false);

  useEffect(() => {
    setPreLoader(true);
    const timer = setTimeout(() => {
      setPreLoader(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      {/* header */}
      <HeaderComponent login={false} openPopup={openLoginPopup} />
      {/* main  banner */}
      <MainBanner login={false} openPopup={openLoginPopup} />

      <MobileMainBanner login={false} openPopup={openLoginPopup} />
      {/* featured games */}
      <FeaturedGames
        login={false}
        openPopup={openLoginPopup}
        setSelectedGameType={setSelectedGameType}
        openGeneralModal={openGeneralModal}
      />
      {/* inner banner */}
      {/* <InnerBanner openLoginPopup={openLoginPopup} login={false} /> */}
      {/* <Promotions login={false} openPopup={openLoginPopup} /> */}
      {/* guest games */}
      <GamesWrapper
        selectedGameAreaType={selectedGameAreaType}
        login={false}
        openPopup={openLoginPopup}
        gameWrapperArea={gameWrapperArea}
      />
      {/* footer area */}
      <FooterComponent
        setOpenCashier={setOpenCashier}
        login={false}
        openPopup={openLoginPopup}
        generalModalStatus={generalModalStatus}
        closePopup={closePopup}
        generalModalType={generalModalType}
        openGeneralModal={openGeneralModal}
      />
      {/* login modal component */}
      <LoginModalWrapper
        openPopup={openPopup}
        type={modalType}
        status={modalStatus}
        closePopup={closePopup}
        changeContent={changeContent}
        openGeneralModal={openGeneralModal}
      />

<PoyaBanneer />
{/* <CryptoBanner /> */}


    </div>
  );
};

export default FirstPage;
